// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconMnt } from "../../../icons/mono/build/icon-mnt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const MntIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconMnt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  MntIcon.displayName = 'MntIcon';
}

export default MntIcon;